import { FormInstance, message } from 'antd';
import { NavigateFunction } from 'react-router-dom';
import { contentProviderService } from '../services/contentProviderService';

interface ContentProviderAddHandlersHook {
  form: FormInstance;
  navigate: NavigateFunction;
}

interface ContentProviderAddHandlersReturn {
  onFinish: () => Promise<void>;
}

export const getContentProviderAddHandlers = ({
  form,
  navigate,
}: ContentProviderAddHandlersHook): ContentProviderAddHandlersReturn => {
  const onFinish = async (): Promise<void> => {
    const loadingMessage = message.loading('Creating...', 0);
    try {
      const values = await form.validateFields();
      await contentProviderService.create(values);
      loadingMessage();
      navigate('/content-provider');
    } catch (error) {
      loadingMessage();
      console.error('Failed to create:', error);
    }
  };

  return {
    onFinish,
  };
};
